// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__Zb5Qf","isTypeView":"styles_isTypeView__vHjR_"};
module.exports.__checksum = "ad3abd0234fd"